import clsx from 'clsx'
import { useId, useState } from 'react'

interface Props {
  value?: string | null
  className?: string
  size?: 'md' | 'lg'
}

/** GET form to /tutorials?q=… (works before hydration and without JavaScript). */
export default function SearchInput({ value, className, size = 'md' }: Props) {
  const [searchQ, setSearchQ] = useState(value ?? '')
  const id = useId()

  return (
    <form
      action="/tutorials"
      role="search"
      className={clsx(
        'flex items-center gap-2 rounded-2xl border-2 border-qt-primary bg-white pl-4',
        size === 'lg' ? 'h-14 pr-2' : 'h-12 pr-1.5',
        className,
      )}
    >
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" className="shrink-0 text-qt-primary" aria-hidden="true">
        <circle cx="11" cy="11" r="7" />
        <path d="m20 20-3.5-3.5" />
      </svg>
      <label htmlFor={id} className="sr-only">
        Search tutorials
      </label>
      <input
        id={id}
        name="q"
        type="search"
        value={searchQ}
        onChange={(e) => setSearchQ(e.target.value)}
        placeholder="Search tutorials"
        className="h-full min-w-0 flex-1 border-0 bg-transparent p-0 text-base font-medium text-qt-text placeholder:text-qt-muted focus:ring-0"
      />
      <button type="submit" className="h-9 shrink-0 rounded-xl bg-qt-primary px-4 text-sm font-bold text-white hover:bg-qt-primary-hover">
        Search
      </button>
    </form>
  )
}
